export class Industry {
    public name: string;
    public codeValue: string;
    // industryCode:string;
    // industryName:string;
    // compunds:Compound[];
    public constructor(init: Partial<Industry>) {
        Object.assign(this, init);
    }
}
